import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';

@Injectable()
export class SessionTimerInterceptor implements HttpInterceptor {
  constructor(
    private sessionService: SessionService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const regexUrl = /\/rest\/(callService\/.*|viewIntegration\/getViewContent\/.*)/;
    if (regexUrl.test(request.url)) {
      this.sessionService.keepAlive = Math.round(new Date().getTime() / 1000);
    }
    return next.handle(request);
  }
}
